"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeDeleteEvaluatorModal = exports.openDeleteEvaluatorModal = exports.deleteEvaluatorSuccess = exports.deleteEvaluatorError = exports.deleteEvaluator = exports.closeEvaluatorToast = exports.openEvaluatorToast = exports.sendEvaluatorToSystemSuccess = exports.sendEvaluatorToSystemError = exports.sendEvaluatorToSystem = exports.getEvaluatorsGroupsError = exports.getEvaluatorsGroupsSuccess = exports.getEvaluatorsGroups = exports.fillTabs = exports.getTabs = exports.evaluatorsSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    siteTabs: [],
    isDeleteAlertDialogShown: false,
    evaluatorToBeDeleted: null,
    isDeleting: false,
    hasDeletionError: false,
    areTabsLoading: false,
    evaluatorsGroups: [],
    areEvaluatorsGroupsLoading: false,
    hasErrorLoadingEvaluatorsGroups: false,
    isSendingEvaluatorToSystem: false,
    hasSentEvaluatorToSystemSuccess: false,
    hasSentEvaluatorToSystemError: false,
    systemOfEvaluatorToBeDeleted: null,
    rowIndexToBeDeleted: 0,
    evaluatorsToastStatus: { isOpen: false, message: "", status: undefined },
};
exports.evaluatorsSlice = (0, toolkit_1.createSlice)({
    name: "evaluators",
    initialState,
    reducers: {
        getTabs: (state) => {
            state.areTabsLoading = true;
        },
        fillTabs: (state, action) => {
            state.areTabsLoading = false;
            state.siteTabs = action.payload;
        },
        getEvaluatorsGroups: (state) => {
            state.areEvaluatorsGroupsLoading = true;
        },
        getEvaluatorsGroupsSuccess: (state, action) => {
            state.evaluatorsGroups = action.payload;
            state.areEvaluatorsGroupsLoading = false;
            state.hasErrorLoadingEvaluatorsGroups = false;
        },
        getEvaluatorsGroupsError: (state) => {
            state.areEvaluatorsGroupsLoading = false;
            state.hasErrorLoadingEvaluatorsGroups = true;
        },
        sendEvaluatorToSystem: (state, action) => {
            const updatedGroup = state.evaluatorsGroups.find((group) => group.id === action.payload);
            if (updatedGroup) {
                updatedGroup.isLoading = true;
            }
        },
        sendEvaluatorToSystemError: (state) => {
            state.isSendingEvaluatorToSystem = false;
            state.hasSentEvaluatorToSystemError = true;
        },
        sendEvaluatorToSystemSuccess: (state, action) => {
            const updatedGroup = state.evaluatorsGroups.find((group) => group.id === action.payload.groupId);
            if (updatedGroup) {
                updatedGroup.evaluators = action.payload.evaluators;
                updatedGroup.isLoading = false;
            }
            state.isSendingEvaluatorToSystem = false;
            state.hasSentEvaluatorToSystemSuccess = true;
        },
        openEvaluatorToast: (state, action) => {
            state.evaluatorsToastStatus.status = action.payload.status;
            state.evaluatorsToastStatus.message = action.payload.message;
            state.evaluatorsToastStatus.isOpen = true;
        },
        closeEvaluatorToast: (state) => {
            state.evaluatorsToastStatus.isOpen = false;
            state.evaluatorsToastStatus.status = undefined;
            state.evaluatorsToastStatus.message = "";
        },
        openDeleteEvaluatorModal: (state, action) => {
            state.isDeleteAlertDialogShown = true;
            state.evaluatorToBeDeleted = action.payload.evaluatorToBeDeleted;
            state.systemOfEvaluatorToBeDeleted =
                action.payload.systemOfEvaluatorToBeDeleted;
        },
        closeDeleteEvaluatorModal: (state) => {
            state.isDeleteAlertDialogShown = false;
            state.evaluatorToBeDeleted = null;
        },
        deleteEvaluator: (state) => {
            state.isDeleting = true;
        },
        deleteEvaluatorSuccess: (state, action) => {
            const updatedGroup = state.evaluatorsGroups.find((group) => group.id === action.payload.systemId);
            if (updatedGroup) {
                updatedGroup.evaluators = action.payload.updatedEvaluators;
            }
            state.isDeleting = false;
            state.isDeleteAlertDialogShown = false;
            state.evaluatorToBeDeleted = null;
            state.hasDeletionError = false;
        },
        deleteEvaluatorError: (state) => {
            state.isDeleting = false;
            state.hasDeletionError = true;
        },
        setRowIndexToBeUnlinked: (state, action) => {
            state.rowIndexToBeDeleted = action.payload;
        },
    },
});
_a = exports.evaluatorsSlice.actions, exports.getTabs = _a.getTabs, exports.fillTabs = _a.fillTabs, exports.getEvaluatorsGroups = _a.getEvaluatorsGroups, exports.getEvaluatorsGroupsSuccess = _a.getEvaluatorsGroupsSuccess, exports.getEvaluatorsGroupsError = _a.getEvaluatorsGroupsError, exports.sendEvaluatorToSystem = _a.sendEvaluatorToSystem, exports.sendEvaluatorToSystemError = _a.sendEvaluatorToSystemError, exports.sendEvaluatorToSystemSuccess = _a.sendEvaluatorToSystemSuccess, exports.openEvaluatorToast = _a.openEvaluatorToast, exports.closeEvaluatorToast = _a.closeEvaluatorToast, exports.deleteEvaluator = _a.deleteEvaluator, exports.deleteEvaluatorError = _a.deleteEvaluatorError, exports.deleteEvaluatorSuccess = _a.deleteEvaluatorSuccess, exports.openDeleteEvaluatorModal = _a.openDeleteEvaluatorModal, exports.closeDeleteEvaluatorModal = _a.closeDeleteEvaluatorModal;
exports.default = exports.evaluatorsSlice.reducer;
